export enum NotificationType {
  ERROR = 'ERROR',
  INFO = 'INFO'
}

export type Notification = NotificationType.ERROR | NotificationType.INFO
